/**
 * Wagtail StreamField block-picker iframe loads these paths with minimal app chrome and no
 * site listing / auth bootstrap (see main.ts).
 */
export function isBlockPreviewPathname(pathname: string): boolean {
  return pathname === '/block-preview' || pathname.startsWith('/block-preview/');
}
